import { END_POINTS } from "../constants/url";
import { PushNotif } from "../types/General";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
};

type NotificationBody = {
  role: number;
  type: number
  title: string
  message: string
}

export const notificationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<
      CommonResponseType &{data:{
        data: {
          role: number;
          createdAt: string;
          broadCastType: number
          title: string
          message: string
          _id: string;
        }[]
        count: number
      }},
      
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.notification}?page=${page}&limit=${limit}${search?.length ? `&search=${search}` : ""
          }`,
        method: "GET",
      }),
    }),
    addNotification: builder.mutation<
      CommonResponseType & { data: Notification },
      NotificationBody
    >({
      query: (body) => ({
        url: END_POINTS.notification,
        method: "POST",
        body,
      }),
    }),
    deleteNotification: builder.mutation<CommonResponseType, { id: string }>({
      query: (body) => ({
        url: `${END_POINTS.notification}`,
        method: "DELETE",
        body,
      }),
    }),
    deleteRecieve: builder.mutation<CommonResponseType, { id: string }>({
      query: (body) => ({
        url: `${END_POINTS.receivedNotification}`,
        method: "DELETE",
        body,
      }),
    }),

    receiveNotification: builder.query<
    CommonResponseType &{data:{
      data: PushNotif[]
      count: number
    }},
    
    {
      page: number;
      limit: number;
      search: string;
    }
  >({
    query: ({ page, limit, search }) => ({
      url: `${END_POINTS.receivedNotification}?page=${page}&limit=${limit}${search?.length ? `&search=${search}` : ""
        }`,
      method: "GET",
    }),
  }),
  }),
});
export const {
  useAddNotificationMutation,
  useDeleteNotificationMutation,
  useLazyGetNotificationsQuery,
  useLazyReceiveNotificationQuery,
  useDeleteRecieveMutation
} = notificationApi;
